import { bubEvents } from 'shared/events/bub_events';
import { giftCardUtils } from 'shared/utils/gift_card_utils';

$(document).ready(() => {
  const menuToggle = $('.your-account-link');
  const menu = $('.account-dropdown-target');
  const icon = $('.account-menu-icon');
  const text = $('.account-text');

  const closeDropdownDelayMs = 700;
  const openDropdownDelayMs = 300;

  let closeDropdownTimer;
  let openDropdownTimer;
  let menuOpen = false;

  if (menu) {
    const isClickOnMenuToggle = target => target.is(menuToggle) || target.is(icon) || target.is(text);
    const isClickOutsideMenu = target => menu.has(target).length === 0;

    const closeMenu = () => {
      menuOpen = false;
      menu.fadeOut('fast').removeClass('active');
    };

    const openMenu = () => {
      menuOpen = true;
      giftCardUtils.viewBalance();
      menu.fadeToggle('fast').addClass('active');
    };

    const onMouseAwayFromMenu = () => {
      if (menuOpen) {
        closeDropdownTimer = setTimeout(() => {
          closeMenu(menu);
        }, closeDropdownDelayMs);
      } else {
        clearTimeout(openDropdownTimer);
      }
    };

    const onMouseOverMenu = () => {
      if (!menuOpen) {
        openDropdownTimer = setTimeout(() => {
          openMenu();
        }, openDropdownDelayMs);
      } else {
        clearTimeout(closeDropdownTimer);
      }
    };

    $(document).on('click touch', event => {
      if (isClickOnMenuToggle($(event.target))) {
        event.stopPropagation();
      }

      if (menuOpen && isClickOutsideMenu($(event.target)) && !isClickOnMenuToggle($(event.target))) {
        closeMenu();
      }
    });

    menuToggle.mouseenter(onMouseOverMenu);

    menuToggle.mouseleave(onMouseAwayFromMenu);

    menu.mouseenter(() => {
      clearTimeout(closeDropdownTimer);
    });

    menu.mouseleave(onMouseAwayFromMenu);
  }

  $('.account-dropdown .my-library-link').on('click touch', () => {
    bubEvents.track('Header account', 'Clicked link', {
      label: 'My Library',
    });
  });

  $('.account-dropdown .my-wishlist-link').on('click touch', () => {
    bubEvents.track('Header account', 'Clicked link', {
      label: 'My Wishlist',
    });
  });

  $('.account-dropdown .order-history-link').on('click touch', () => {
    bubEvents.track('Header account', 'Clicked link', {
      label: 'Order History',
    });
  });

  $('.account-dropdown .settings-link').on('click touch', () => {
    bubEvents.track('Header account', 'Clicked link', {
      label: 'Settings',
    });
  });

  $('.account-dropdown .invite-friends-link').on('click touch', () => {
    bubEvents.track('Header account', 'Clicked link', {
      label: 'Invite Friends',
    });
  });

  $('.account-dropdown .give-gift-card-link').on('click touch', () => {
    bubEvents.track('Header account', 'Clicked link', {
      label: 'Give a Gift Card',
    });
  });

  $('.account-dropdown .claim-gift-card-link').on('click touch', () => {
    bubEvents.track('Header account', 'Clicked link', {
      label: 'Claim a Gift Card',
    });
  });

  $('.account-dropdown .sign-out-link').on('click touch', () => {
    bubEvents.track('Header account', 'Clicked link', {
      label: 'Sign out',
    });
  });
});
